import { render, staticRenderFns } from "./DistributionTab.vue?vue&type=template&id=65df375c&scoped=true"
import script from "./DistributionTab.vue?vue&type=script&lang=js"
export * from "./DistributionTab.vue?vue&type=script&lang=js"
import style0 from "./DistributionTab.vue?vue&type=style&index=0&id=65df375c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65df375c",
  null
  
)

export default component.exports